// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"iN-z","inlineTitle":"jN-z","sponsoredAdsWrapper":"kN-z","marketplaceRecosWrapper":"lN-z"};